import { round, sumBy } from 'lodash';
import { useFormContext } from 'react-hook-form';
import { UpdateCapitalActionFormValues } from 'routes/LpPages/CapitalActions/AddEditCapitalAction/hooks/useCapitalActionForm';
import aggregateActionsBreakdown from '../../hooks/useAggregateActionsBreakdown';

export default function useActionAllocationsChangeHandler(entryIndex: number) {
  const { setValue, getValues } =
    useFormContext<UpdateCapitalActionFormValues>();

  return (
    actionId: string,
    capitalBreakdown: Array<{
      commitmentId: string;
      fundsCalled?: {
        fromCommitmentLcy: number;
        fromRecallableDistributionLcy: number;
      };
    }>,
  ) => {
    const currentActions = getValues(`entries.${entryIndex}.actions`);

    if (currentActions.find((action) => action.id === actionId)) {
      return;
    }

    const updatedActions = currentActions.map((action) => {
      return {
        ...action,
        capitalBreakdown:
          action.id === actionId ? capitalBreakdown : action.capitalBreakdown,
      };
    });

    const aggregatedActionsBreakdown =
      aggregateActionsBreakdown(updatedActions);

    setValue(`entries.${entryIndex}.actions`, updatedActions);

    setValue(
      `entries.${entryIndex}.capitalBreakdown`,
      aggregatedActionsBreakdown,
    );

    setValue(
      `entries.${entryIndex}.totalAmountLcy`,
      round(
        sumBy(aggregatedActionsBreakdown, (breakdown) =>
          round(
            (breakdown.fundsCalled?.fromCommitmentLcy ?? 0) +
              (breakdown.fundsCalled?.fromRecallableDistributionLcy ?? 0),
            2,
          ),
        ),
        2,
      ),
    );
  };
}
